import React, { type FC } from 'react';
import { useSelector } from 'react-redux';
import { familyFeatureDocuments } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { useShowFamilyCalendarHook } from 'reactApp/hooks/useFamilyShowHook';
import { getFamilyContentCategory } from 'reactApp/modules/familyContent/familyContent.selectors';
import { FamilyContentCategoryType } from 'reactApp/modules/familyContent/familyContent.types';
import { FamilyDocumentsEmptyState } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/FamilyDocuments';
import { FamilySubscription } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/FamilySubscription';
import { SharedAlbums } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/SharedAlbums';
import { SharedBusiness } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/SharedBusiness';
import { SharedFolders } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/SharedFolders';
import { SharedMemories } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/SharedMemories';

import styles from './FamilyContentEmpty.css';
import { SharedCalendar } from './FamilyContentEmptyCards/SharedCalendar';

const SHARED_MAP: Record<FamilyContentCategoryType, FC> = {
    [FamilyContentCategoryType.albums]: () => {
        return (
            <>
                <SharedAlbums />
                <SharedMemories />
            </>
        );
    },

    [FamilyContentCategoryType.folders]: () => {
        return (
            <>
                <SharedFolders />
                <SharedBusiness />
            </>
        );
    },
};

export const FamilyContentEmpty: React.FC = () => {
    const type: FamilyContentCategoryType = useSelector(getFamilyContentCategory);
    const Shared = SHARED_MAP[type];
    const showFamilyCalendar = useShowFamilyCalendarHook();

    const handleWheel = (event: React.WheelEvent<HTMLDivElement>) => {
        event.preventDefault();
        const scrollAmount = event.deltaY;
        event.currentTarget.scrollLeft += scrollAmount;
    };

    return (
        <div className={styles.root} data-qa-id="family-empty">
            <div className={styles.list} onWheel={handleWheel}>
                <Shared />
                {showFamilyCalendar && <SharedCalendar paySource={`family-preview-${type}`} />}
                {familyFeatureDocuments ? <FamilyDocumentsEmptyState /> : <FamilySubscription />}
            </div>
        </div>
    );
};
